import {
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
} from '@chakra-ui/react';
import { CheckCircle } from '@phosphor-icons/react';
import { AcfServiceTabs, ServiceTabsProps } from '../../types';
import HtmlContent from '../HtmlContent';
import Tab from '../Tab';

interface ServiceTabProps {
  tab: AcfServiceTabs;
}

const ServiceBenefits = ({ items }) => (
  <SimpleGrid columns={[1, 1, 1, 3]} spacing={5}>
    {items?.map((item) => (
      <Flex key={item.title}>
        <Box color="greenSpruce" mr={3}>
          <CheckCircle size="35" />
        </Box>
        <Box>
          <Heading as="h4" variant="h4" mb={5}>
            {item.title}
          </Heading>
          <Text mb={5}>{item.text}</Text>
        </Box>
      </Flex>
    ))}
  </SimpleGrid>
);

const ServiceTabPanel = ({ tab }: ServiceTabProps) =>
  (() => {
    if (!tab.content) {
      return null;
    }
    switch (tab.name) {
      case 'benefits':
        return typeof tab.content !== 'string' ? (
          <ServiceBenefits items={tab.content} />
        ) : null;
      default:
        return typeof tab.content === 'string' ? (
          <Box sx={{ '*:first-child': { marginTop: '0' } }}>
            <HtmlContent optionModifier="restrictHeadings" html={tab.content} />
          </Box>
        ) : null;
    }
  })();

const ServiceTabs = ({ data: tabs }: ServiceTabsProps) => {
  if (!tabs) {
    return null;
  }

  const activeTabs = tabs?.filter((tab) => tab.content);

  if (!activeTabs.length) {
    return null;
  }
  return (
    <Box
      bg="gray1"
      borderRadius={[0, 'lg']}
      gridColumn={['1 / -1', '2']}
      pl={[5, 6, 10]}
      py={[5, 6, 10]}
    >
      <Tabs size="lg">
        <TabList
          borderBottom="none"
          mb={5}
          overflowX="auto"
          overflowY="hidden"
          pr={['1px', 6, 10]}
          sx={{ scrollSnapType: 'x proximity', scrollBarWidth: 'none' }}
        >
          {activeTabs?.map((tab) => (
            <Tab key={tab.name}>{tab.title}</Tab>
          ))}
        </TabList>
        <TabPanels pr={[5, 6, 10]}>
          {activeTabs?.map((tab) => (
            <TabPanel px={0} key={tab.name}>
              <ServiceTabPanel tab={tab} />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default ServiceTabs;
